import { Link } from 'react-router-dom';
import { site } from '@/mocks/site';

export default function CtaSection() {
  return (
    <section id="submit" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="relative overflow-hidden rounded-lg bg-secondary-900 px-6 py-12 md:px-12 md:py-16">
          <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-secondary-800/60"></div>
          <div className="absolute -bottom-16 left-1/3 h-48 w-48 rounded-full bg-primary-500/20"></div>

          <div className="relative z-10 flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-800 px-3.5 py-1.5 text-xs text-secondary-100">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-inbox-archive-line"></i>
                </span>
                线索长期征集
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold text-secondary-50 md:text-3xl">
                手里有原始材料？交给我们排一条时间线
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-secondary-200 md:text-base">
                比起结论，我们更需要带时间和来源的原始链接。你提供的每一条信息，我们都会先核对再决定是否整理进复盘。
              </p>
            </div>

            <div className="flex shrink-0 flex-col gap-3">
              <Link
                to="/contact"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-line"></i>
                前往投稿表单
              </Link>
              <a
                href={`mailto:${site.submitEmail}`}
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border border-secondary-700 px-7 py-3 text-sm text-secondary-100 transition-colors hover:bg-secondary-800"
              >
                <i className="ri-mail-line"></i>
                {site.submitEmail}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}